import DisableSmoothScroll from './DisableSmoothScroll';

const disableSmoothScroll = new DisableSmoothScroll();

export { disableSmoothScroll };
